import React, { createContext, useState } from 'react';

// Contextの作成
export const FilenameContext = createContext();

// Context Providerの作成
export const FilenameProvider = ({ children }) => {
    // 初期値の定義
    const initialFilenameState = ''; 
    const initialTokenState = ''; 

    // 状態管理
    const [filename, setFilename] = useState(initialFilenameState);
    const [tempfilename, settempFilename] = useState(initialFilenameState);
    const [token, setToken] = useState(initialTokenState);

    // リセット関数
    const resetFilename = () => {
        setFilename(initialFilenameState);
        setToken(initialTokenState);
        settempFilename(initialFilenameState);
    };

    return (
        <FilenameContext.Provider 
            value={{
                filename,
                setFilename,
                tempfilename,
                settempFilename,
                token,
                setToken,
                resetFilename
            }}
        >
            {children}
        </FilenameContext.Provider>
    );
};
